import PropTypes from "prop-types"

const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter, t) => [
  {
    title: t("staff.table.name"),
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: sorter.field === "name" ? sorter.order : null,
    width: 200,
    "aria-sort": getSortDirection(sorter, "name"),
    "aria-label": t("staff.table.aria_name_sortable")
  },
  {
    title: t("staff.table.title"),
    dataIndex: "title",
    key: "title",
    sorter: true,
    sortOrder: sorter.field === "title" ? sorter.order : null,
    width: 150,
    "aria-sort": getSortDirection(sorter, "title"),
    "aria-label": t("staff.table.aria_title_sortable")
  },
  {
    title: t("staff.table.role"),
    dataIndex: "role",
    key: "role",
    sorter: true,
    sortOrder: sorter.field === "role" ? sorter.order : null,
    width: 120,
    "aria-sort": getSortDirection(sorter, "role"),
    "aria-label": t("staff.table.aria_role_sortable")
  },
  {
    title: t("staff.table.phone"),
    dataIndex: "phone",
    key: "phone",
    width: 160,
    "aria-label": t("staff.table.aria_phone")
  },
  {
    title: t("staff.table.email"),
    dataIndex: "email",
    key: "email",
    width: 200,
    "aria-label": t("staff.table.aria_email")
  },
  {
    title: t("staff.table.status"),
    dataIndex: "status",
    key: "status",
    sorter: true,
    sortOrder: sorter.field === "status" ? sorter.order : null,
    width: 120,
    "aria-sort": getSortDirection(sorter, "status"),
    "aria-label": t("staff.table.aria_status_sortable")
  },
  {
    title: t("staff.table.actions"),
    dataIndex: "actions",
    width: 60,
    align: "right",
    key: "actions",
    "aria-label": t("staff.table.aria_actions")
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object,
  t: PropTypes.func.isRequired
}

export { getHeaders }
